import { LANDING_URL } from '@ethena/shared-ui/src/constants/url'

import { IS_GERMAN } from '.'

export const REDEMPTION_START_DATE = '25 June 2025'
export const REDEMPTION_START_TIME = '12:00 CEST'
export const REDEMPTION_END_DATE = '06 August 2025'
export const REDEMPTION_END_TIME = '23:59 CET'
const baseUrl = IS_GERMAN ? 'https://ethena.gmbh' : LANDING_URL
export const REDEMPTION_PAGE = baseUrl + '/redemption'
